<template>
<div style="min-height:200px;">
  <el-row type="flex" justify="space-between" class="title-bar">
    <w-perf-analysis-time-info :checkDatetime="checkDatetime" @change="onTimeTypeChange" @reload="onCurrentDataLoad"/>
    <w-header-search-button @click="onClickSetSearchToolVisible"></w-header-search-button>
  </el-row>
  <el-table-wrapper :data="tableList" :columns="columns" :pagination="true" :column-default="columnDefault" :show-custom-header="true" :show-search-tool="showSearchTool" ref="table" style="width:100%;"
  :show-overflow-tooltip="true" :span-method="objectSpanMethod">
  </el-table-wrapper>
</div>
</template>
<script>
import find from 'lodash/find';
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import remove from 'lodash/remove';
import { analysisTimeType } from '@/constants/performance';
import { getValueAfterCheckEmpty } from '@/utils/string';
import { columnDefault } from '@/constants/table';
import WPerfAnalysisTimeInfo from '@/views/performance/node/analysis/components/PerfAnalysisTimeInfo';

export default {
  name: 'WConnectionDeviceTable',
  components: {
    WPerfAnalysisTimeInfo,
  },
  props: {
    tableData: {
      type: Object,
    },
  },
  data() {
    return {
      analysisTimeType,
      columnDefault,
      checkDatetime: null,
      tableList: [],
      mergeRowList: [],
      columns: [
        {
          prop: 'objName',
          label: '연결 장비명',
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'ipaddress',
          label: 'IP주소',
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'macaddress',
          label: 'MAC',
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'companyName',
          label: 'NIC 제조사',
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
      showSearchTool: false,
    };
  },
  watch: {
    /**
     * [tableData 병합을 위해 기본 설정을 한다.]
     * @author {Yang}
     * @return {[type]} [description]
     */
    tableData: {
      handler() {
        if (isEmpty(this.tableData)) {
          this.tableList = [];
          this.checkDatetime = null;
        } else {
          if (this.tableData.timeType === this.analysisTimeType.HIST.value) {
            this.tableList = this.tableData.snapshotDoc;
          } else {
            this.tableList = this.tableData.currentList;
          }
          this.checkDatetime = this.tableData.timestamp;
        }
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * [objectSpanMethod 병합 메서드]
     * @author {Yang}
     * @param  {[type]} row         [description]
     * @param  {[type]} columnIndex [description]
     * @param  {[type]} }           [description]
     * @return {[type]}             [description]
     */
    objectSpanMethod({ row, columnIndex }) {
      if (columnIndex === 0) {
        const obj = find(this.mergeRowList, {
          objName: row.objName,
        });
        if (!isNil(obj)) {
          remove(this.mergeRowList, obj);
          return [obj.count, 1];
        } else if (isNil(obj) && isEmpty(this.mergeRowList)) {
          return [1, 1];
        }
        return [0, 0];
      }
      return [1, 1];
    },
    onClickSetSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} valu
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    onTimeTypeChange(value) {
      this.$emit('time-type-change', value);
    },
    onCurrentDataLoad() {
      this.$emit('reload');
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/netinterface/components/ConnectionDeviceTable.vue